import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { BILLING_ROUTE } from '../main/main.data';
import { BILLING_MANAGE_RENEW_ROUTE } from './billing-data.data';
import { environment } from '../../../environments/environment';

export const BASE_PATH = {
  SUBSCRIPTION: '/subscription',
};

@Injectable()
export class BillingDataBuilder {
  constructor() {}

  buildSubscriptionUrl(path: string): { url: string } {
    const url = Location.joinWithSlash(BASE_PATH.SUBSCRIPTION, path);

    return {
      url,
    };
  }

  buildPostPurchaseKey(accountId: string): string {
    return `post_purchase_${accountId}`;
  }

  /**
   * Build renew url of Billing app
   */
  buildRenewUrlOfBillingApp() {
    return [
      environment.billingUrl,
      BILLING_ROUTE,
      BILLING_MANAGE_RENEW_ROUTE,
    ].join('/');
  }
}
